module.exports = __webpack_public_path__ + "img/clinicimg3.138332d8.jpg";